import React, { createContext, useContext, useEffect } from 'react';
import { useCurrentPortalMode } from '@/hooks/useCurrentPortalMode';

type NannyThemeContextType = {
  isNannyMotherWorkspace: boolean;
  currentWorkspace: 'nanny' | 'mother' | null;
};

const NannyThemeContext = createContext<NannyThemeContextType>({
  isNannyMotherWorkspace: false,
  currentWorkspace: null,
});

export const NannyThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const portalMode = useCurrentPortalMode();
  const isNannyMotherWorkspace = portalMode === 'nanny' || portalMode === 'mother';
  const currentWorkspace = isNannyMotherWorkspace ? portalMode : null;

  // Apply workspace-specific class to html element for global styling
  useEffect(() => {
    const html = document.documentElement;
    
    if (isNannyMotherWorkspace) {
      html.setAttribute('data-workspace', currentWorkspace!);
    } else {
      html.removeAttribute('data-workspace');
    }

    return () => {
      html.removeAttribute('data-workspace');
    };
  }, [isNannyMotherWorkspace, currentWorkspace]);

  return (
    <NannyThemeContext.Provider value={{ isNannyMotherWorkspace, currentWorkspace }}>
      {children}
    </NannyThemeContext.Provider>
  );
};

export const useNannyTheme = () => useContext(NannyThemeContext);
